// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"A2-z","displaySixCardTiles":"B2-z"};